<template>
	<div class="upImg">
		<my-dialog :title="title" :visible.sync="editFormVisible" @close="closeDialog" @click="closeDialog"
			:close-on-click-modal='false'>
			<div class="up_01">
				<el-upload class="upload-demo avatar-uploader-cover" :headers="headers" :data="editPhoto" ref="upload"
					:multiple="false" :action="action" :before-remove="handleRemove" :on-success="progress"
					:on-change="imgChange" :on-remove="imgRemove" :limit="1" :on-exceed="handleExceed"
					list-type="picture-card" :class="{ hide: hideUpload }" :auto-upload="true">
					<i slot="default" class="el-icon-plus"></i>
				</el-upload>
			</div>
		</my-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			editFormVisible: false,
			fileList: [{
				url: "",
				uid: ""
			}],
			loading: false,
			dialogVisibleImg: false,
			onlyOne: true,
			hideUpload: false,
			limitCount: 1,
			title: '',
			headers: {
				"Authorization": 'Bearer ' + localStorage.getItem('logintoken'),
			},
			action: '',
			// 签名、人员照片
			editPhoto: {
				KeyId: '',
			}
		}
	},
	methods: {
		imgChange(file, fileList) {
			//获取上传文件大小
			let imgSize = Number(file.size / 1024 / 1024);
			if (imgSize > 2) {
				this.$msgbox({
					title: "",
					message: "文件大小不能超过2MB，请重新上传。",
					type: "warning",
				});
				this.$refs.upload.clearFiles();
				return;
			}
			this.hideUpload = fileList.length >= this.limitCount;
		},
		handlePictureCardPreview(file) {
			// this.dialogImageUrl = file.url;
			this.dialogVisibleImg = true;
		},
		handleExceed(files, fileList) {
			this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
		},
		upImgGo(row, name) {
			if (row != undefined && row != 'undefined') {
				this.editPhoto.KeyId = row.keyId;
				this.loading = true
				if (name == true) {
					this.title = '上传签名'
					this.dialogImageUrl = row.signImg
					this.action = '/api/sysConfig/User/UpdateUserSignature'
					this.editFormVisible = true
				} else if (name == false) {
					this.action = '/api/sysConfig/User/UpdateUserPhoto'
					this.title = '上传照片'
					this.dialogImageUrl = row.photoImg
					this.editFormVisible = true
				}
			}
		},
		closeDialog() {
			this.editFormVisible = false;
		},
		/**     文件上传成功时的钩子    **/
		progress(event, file) {
			this.onlyOne = false
			this.editFormVisible = false;
			this.$refs.upload.clearFiles()
			this.$parent.getListData()

		},
		imgRemove(file, fileList) {
			this.hideUpload = fileList.length >= this.limitCount;
		},
		/**     移除上传文件    **/
		handleRemove(file) {
			return this.$confirm(`确认移除 ${file.name}?`)
				.then(() => {
					this.$parent.getListData()
				})
		},
	}
}
</script>
<style>
::deep .el-upload {
	padding-bottom: 20px;
}

::deep .hidden-Btn .el-upload--picture-card {
	display: none !important;
}

.hide .el-upload--picture-card {
	display: none;
}

.up_01 {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>